import React from 'react';
import { makeStyles, Typography, Paper} from '@material-ui/core';


const Results = ({src, title, description, price, stock}) => {

	const classes = useStyles();

	return (
		<Paper className={classes.root}>
			<div className={classes.left}>
				<img className={classes.image} src={src} alt={title} />
			</div>
			<div className={classes.right}>
				<Typography variant='h6'>
					{title}
				</Typography>
				<Typography variant='body1'>
					{description}
				</Typography>
				<Typography variant='body1'>
					Price per night: {"    "}
					<span className={classes.number}>$ {price}</span>
				</Typography>
				<Typography variant='body2'>
					Rooms Available: {"    "}
					<span className={classes.number}>{stock}</span> 
				</Typography>
			</div>
		</Paper>
	)
}

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2),
    padding: theme.spacing(1),
    display: "flex",
    justifyContent: "flex-start",
    [theme.breakpoints.down("xs")]: {
  		flexDirection: "column",
  	},
  },
  left: {
  	margin: theme.spacing(2,5,5,5),
  },
  image: {
  	maxWidht: "400px",
  	height: "auto",
  	borderRadius: "10px",
  	[theme.breakpoints.down("xs")]: {
  		maxWidht: "200px",
  		height: "auto",
  	},
  },
  number:{
  	fontWeight: "bold",
  	marginLeft: theme.spacing(1),
  	fontSize: "1.1rem"
  }
   
}));

export default Results